import CarouselImages from './CarouselImages';

export default CarouselImages;
